export const getRevyreDetailsDefaultState = () => ({
  profileCardData: { header: [], body: [] },
  inputsMap: {},
  referredDoDetails: [],
  profiles: [],
  allowedActions: [],
  quickActions: [],
  activities: {},
  referredEntityDetails: [],
});
